import { useNavigate } from "react-router-dom";
import { getLocalFranchiseStore, getStoreLocalData, getUserData } from "../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import { useEffect, useState } from "react";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getAdminStoreWiseReports } from "../../services/Reports/Reports";
import StoreReportUserFilterModal from "./StoreReportUserFilterModal";
import { getBrandStore } from "../../services/StoreUsers/PostStoreUsers";
import AdminMenu from "../AdminMenu";
import { Calendar } from "primereact/calendar";
import { localeDateEndDate, localeDateStartDate } from "../../constants/DateUtil/DateUtil";

const { innerHeight: height } = window;

const AdminReports = () => {
  const navigate = useNavigate();

  const { userProfileRole, brandProfileData } = getUserData();

  const userRole = userProfileRole;
  let brandId = brandProfileData.id;
  let enabledAmountRoundOffAdmin = brandProfileData.enabledAmountRoundOff ? 0 : 2;

  const { storeLocalData } = getStoreLocalData();

  const [storeNameData, setStoreNameData] = useState("");
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");

  const [invoiceNoResData, setInvoiceNoResData] = useState([]);
  const [packageResData, setPackageResData] = useState([]);
  const [walletResData, setWalletResData] = useState([]);

  const [filteredDataInvoice, setFilteredDataInvoice] = useState([]);
  const [filteredDataPackage, setFilteredDataPackage] = useState([]);
  const [filteredDataWallet, setFilteredDataWallet] = useState([]);

  const [statusTotalData, setStatusTotalData] = useState({});
  const [statusTotalPackageData, setStatusTotalPackageData] = useState({});
  const [statusTotalWalletData, setStatusTotalWalletData] = useState({});
  // const [sumOfGrandTotal, setSumOfGrandTotal] = useState(0);
  // const [sumOfOrderCount, setSumOfOrderCount] = useState(0);

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedEndDate, setSelectedEndDate] = useState(new Date());

  const [reportUsersModalVisible, setReportUsersModalVisible] = useState(false);

  const [searchFilterValue, setSearchFilterValue] = useState("");
  const [paymentStoreUserName, setPaymentStoreUserName] = useState([]);

  const [resData, setResData] = useState([]);
  const [allTotalData, setAllTotalData] = useState([]);

  const [selectedStore, setSelectedStore] = useState("");

  const fetchStoreOrderReport = (id, data) => {
    setLoading(true);
    getAdminStoreWiseReports(id, data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;

          const paymentModeUser = Array.from(
            new Set(
              response.data
                .flatMap((order) =>
                  order.collectionList.map((c) => c.storeUserName)
                )
                .filter(Boolean) // removes undefined or empty string
            )
          );

          setPaymentStoreUserName(paymentModeUser);

          // const InvoiceNoRes = Res.filter(order => order.invoiceNo);
          const InvoiceNoRes = Res.filter((order) => order.invoiceNo).sort(
            (a, b) => b.invoiceNo.localeCompare(a.invoiceNo)
          );
          const PackageRes = Res.filter(
            (order) => order.invoiceNo === null && order.subscriptionPackageInfo
          );
          const WalletRes = Res.filter(
            (order) =>
              order.invoiceNo === null && order.subscriptionPackageInfo === null
          );

          setResData(Res);
          updateResTotals(Res);

          setInvoiceNoResData(InvoiceNoRes); // Reset state with new data
          updateInvoiceNoResTotals(InvoiceNoRes); // Calculate totals based on the fresh data

          setPackageResData(PackageRes); // Reset state with new data
          updatePackageResTotals(PackageRes); // Calculate totals based on the fresh data

          setWalletResData(WalletRes); // Reset state with new data
          updateWalletResTotals(WalletRes); // Calculate totals based on the fresh data

          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
     if (userRole === "BY_FRANCHISE_ADMIN") {
       fetchFranchiseStore();
     } else {
       fetchData();
     }
  }, []);

  const handleSearchFilterChange = (selectedItem) => {
    setSearchFilterValue(selectedItem[0]);
  };

  const updateResTotals = (orders) => {
    const paymentModeTotals = {};
    let totalGrandTotalSum = 0;
    let totalOrderCount = 0;

    orders.forEach((order) => {
      totalGrandTotalSum += order.grandTotal || 0;
      totalOrderCount += 1;

      order.collectionList.forEach((collection) => {
        const mode = collection.paymentMode.toUpperCase();
        if (!paymentModeTotals[mode]) {
          paymentModeTotals[mode] = 0;
        }
        paymentModeTotals[mode] += collection.amount || 0;
      });
    });

    setAllTotalData(paymentModeTotals);
  };

  const updateInvoiceNoResTotals = (orders) => {
    const paymentModeTotals = {};
    let totalGrandTotalSum = 0;
    let totalOrderCount = 0;

    orders.forEach((order) => {
      totalGrandTotalSum += order.grandTotal || 0;
      totalOrderCount += 1;

      order.collectionList.forEach((collection) => {
        const mode = collection.paymentMode.toUpperCase();
        if (!paymentModeTotals[mode]) {
          paymentModeTotals[mode] = 0;
        }
        paymentModeTotals[mode] += collection.amount || 0;
      });
    });

    // If needed, update your state here
    setStatusTotalData(paymentModeTotals);
    // setSumOfGrandTotal(totalGrandTotalSum);
    // setSumOfOrderCount(totalOrderCount);
  };

  const updatePackageResTotals = (orders) => {
    const paymentModeTotalsPackage = {};
    let totalGrandTotalSumPackage = 0;
    let totalOrderCountPackage = 0;

    orders.forEach((order) => {
      totalGrandTotalSumPackage += order.grandTotal || 0;
      totalOrderCountPackage += 1;

      order.collectionList.forEach((collection) => {
        const mode = collection.paymentMode.toUpperCase();
        if (!paymentModeTotalsPackage[mode]) {
          paymentModeTotalsPackage[mode] = 0;
        }
        paymentModeTotalsPackage[mode] += collection.amount || 0;
      });
    });

    // If needed, update your state here
    setStatusTotalPackageData(paymentModeTotalsPackage);
    // setSumOfGrandTotal(totalGrandTotalSum);
    // setSumOfOrderCount(totalOrderCount);
  };
  const updateWalletResTotals = (orders) => {
    const paymentModeTotalsWallet = {};
    let totalGrandTotalSumWallet = 0;
    let totalOrderCountWallet = 0;

    orders.forEach((order) => {
      totalGrandTotalSumWallet += order.grandTotal || 0;
      totalOrderCountWallet += 1;

      order.collectionList.forEach((collection) => {
        const mode = collection.paymentMode.toUpperCase();
        if (!paymentModeTotalsWallet[mode]) {
          paymentModeTotalsWallet[mode] = 0;
        }
        paymentModeTotalsWallet[mode] += collection.amount || 0;
      });
    });

    // If needed, update your state here
    setStatusTotalWalletData(paymentModeTotalsWallet);
    // setSumOfGrandTotal(totalGrandTotalSum);
    // setSumOfOrderCount(totalOrderCount);
  };

  const paymentModeColors = {
    CASH: "#3EB3E1",
    CHEQUE: "#866CCE",
    USER_ACCOUNT: "#F5C43A",
    PAYTM: "#09B4AA",
    ONLINE: "#55BD5A",
    CC: "#FF6767",
    DC: "#5D53D8",
    COD: "#6EA4F5",
    GPAY: "#E89534",
    HDFC: "#784409",
    ICICI_PG: "#7b7b06",
    PHONEPE: "#035b55",
    DEFAULT: "#000",
  };

  const renderPaymentModeButtonsInvoice = () => {
    return Object.entries(statusTotalData).map(([mode, amount]) => (
      <div
        key={mode}
        style={{ backgroundColor: paymentModeColors[mode] }}
        className="px-3 py-2 border-round-md"
      >
        <p className="text-white text-lg font-bold uppercase">
          {mode.replace(/_/g, " ")}: {storeLocalData?.currencySymbol} {Number(amount)?.toFixed(enabledAmountRoundOffAdmin)}
        </p>
      </div>
    ));
  };

  const renderPaymentModeButtonsPackage = () => {
    return Object.entries(statusTotalPackageData).map(([mode, amount]) => (
      <div
        key={mode}
        style={{ backgroundColor: paymentModeColors[mode] }}
        className="px-3 py-2 border-round-md"
      >
        <p className="text-white text-lg font-bold uppercase">
          {mode.replace(/_/g, " ")}: {storeLocalData?.currencySymbol} {Number(amount)?.toFixed(enabledAmountRoundOffAdmin)}
        </p>
      </div>
    ));
  };

  const renderPaymentModeButtonsWallet = () => {
    return Object.entries(statusTotalWalletData).map(([mode, amount]) => (
      <div
        key={mode}
        style={{ backgroundColor: paymentModeColors[mode] }}
        className="px-3 py-2 border-round-md"
      >
        <p className="text-white text-lg font-bold uppercase">
          {mode.replace(/_/g, " ")}: {storeLocalData?.currencySymbol} {Number(amount)?.toFixed(enabledAmountRoundOffAdmin)}
        </p>
      </div>
    ));
  };

  // useEffect(() => {
  //   if (!searchTerm) {
  //     setFilteredDataInvoice(invoiceNoResData);
  //     setFilteredDataPackage(packageResData);
  //     setFilteredDataWallet(walletResData);
  //   } else {
  //     const lowerSearch = searchTerm.toLowerCase();
  //     const filteredInvoice = invoiceNoResData.filter((item) =>
  //       Object.values(item).some((val) =>
  //         String(val).toLowerCase().includes(lowerSearch)
  //       )
  //     );
  //     const filteredPackage = packageResData.filter((item) =>
  //       Object.values(item).some((val) =>
  //         String(val).toLowerCase().includes(lowerSearch)
  //       )
  //     );
  //     const filteredWallet = walletResData.filter((item) =>
  //       Object.values(item).some((val) =>
  //         String(val).toLowerCase().includes(lowerSearch)
  //       )
  //     );
  //     setFilteredDataInvoice(filteredInvoice);
  //     setFilteredDataPackage(filteredPackage);
  //     setFilteredDataWallet(filteredWallet);
  //   }
  // }, [searchTerm, invoiceNoResData, packageResData, walletResData]);

  useEffect(() => {
    const lowerSearch = searchTerm?.toLowerCase() || "";
    const filterStore = searchFilterValue || "";

    const applyFilters = (data) =>
      data.filter((item) => {
        // 1) Store‐name filter: check every entry in collectionList
        // const matchesStore = filterStore
        //   ? (Array.isArray(item.collectionList) &&
        //       item.collectionList.some(
        //         (c) => c.storeUserName === filterStore
        //       )) ||
        //     item.editBy === filterStore
        //   : true;

        // const matchesStore = filterStore
        //   ? Array.isArray(item.collectionList) &&
        //     item.collectionList.some((c) => c.storeUserName === filterStore)
        //     ? true
        //     : item.editBy === filterStore
        //   : true;

        const matchesStore = filterStore
          ? Array.isArray(item.collectionList) && item.collectionList.length > 0
            ? item.collectionList.some((c) => c.storeUserName === filterStore)
            : item.editBy === filterStore
          : true;

        if (!matchesStore) return false;

        // 2) Free‐text search: check both top‐level fields and nested collectionList values
        if (lowerSearch) {
          // collect ALL stringifiable values:
          const topLevelVals = Object.entries(item)
            .filter(([key, val]) => key !== "collectionList")
            .map(([_, val]) => String(val).toLowerCase());

          const nestedVals = (item.collectionList || []).flatMap((c) =>
            Object.values(c).map((val) => String(val).toLowerCase())
          );

          const allVals = topLevelVals.concat(nestedVals);

          return allVals.some((val) => val.includes(lowerSearch));
        }

        return true;
      });

    if (!searchFilterValue && !searchTerm) {
      setFilteredDataInvoice(invoiceNoResData);
      setFilteredDataPackage(packageResData);
      setFilteredDataWallet(walletResData);

      updateResTotals(resData);

      updateInvoiceNoResTotals(invoiceNoResData); // Calculate totals based on the fresh data
      updatePackageResTotals(packageResData); // Calculate totals based on the fresh data
      updateWalletResTotals(walletResData); // Calculate totals based on the fresh data
    } else {
      setFilteredDataInvoice(applyFilters(invoiceNoResData));
      setFilteredDataPackage(applyFilters(packageResData));
      setFilteredDataWallet(applyFilters(walletResData));

      updateResTotals(applyFilters(resData));

      updateInvoiceNoResTotals(applyFilters(invoiceNoResData)); // Calculate totals based on the fresh data
      updatePackageResTotals(applyFilters(packageResData)); // Calculate totals based on the fresh data
      updateWalletResTotals(applyFilters(walletResData)); // Calculate totals based on the fresh data
    }
  }, [
    searchTerm,
    searchFilterValue,
    invoiceNoResData,
    packageResData,
    walletResData,
  ]);

  const [brandStoreData, setBrandStoreData] = useState([]);

  const fetchData = async () => {
    try {
      const response = await getBrandStore(brandId);
      if (!response.data.error) {
        const Res = response.data;
        setBrandStoreData(Res);
        const storeIds = Res.map((item) => item.id);
        const storeNames = Res.map((item) => item.storeName);
        setSelectedStore(selectedStore || storeIds[0]);
        const data = {
          reportDate: localeDateStartDate(new Date(selectedDate)),
          endDate: localeDateEndDate(new Date(selectedEndDate))
        };
        fetchStoreOrderReport(storeIds[0], data);
        setStoreNameData(storeNames[0]);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchFranchiseStore = async () => {
    const franchiseStore = await getLocalFranchiseStore();
    if (franchiseStore.franchiseStore !== null) {
      const Res = franchiseStore.franchiseStore.filter((item) => item.status === "ACTIVE");
      setBrandStoreData(Res);
      const storeIds = Res.map((item) => item.id);
      const storeNames = Res.map((item) => item.storeName);
      setSelectedStore(selectedStore || storeIds[0]);
      const data = {
        reportDate: localeDateStartDate(new Date(selectedDate)),
        endDate: localeDateEndDate(new Date(selectedEndDate))
      };
      fetchStoreOrderReport(storeIds[0], data);
      setStoreNameData(storeNames[0]);
    } else {
      setBrandStoreData([]);
      setSelectedStore("");
      setStoreNameData("");
    }
  };

  useEffect(() => {
    if (selectedStore) {
      const data = {
        reportDate: localeDateStartDate(new Date(selectedDate)),
        endDate: localeDateEndDate(new Date(selectedEndDate))
      };
      fetchStoreOrderReport(selectedStore, data);
    }
  }, [selectedDate, selectedEndDate]);

  const renderPaymentModeButtons = () => {
    return brandStoreData?.map((item) => (
      <div
        key={item.id}
        style={{
          backgroundColor: item.id === selectedStore ? "green" : "#3EB3E1",
        }}
        className="px-3 py-2 border-round-md cursor-pointer"
        onClick={() => {
          setSelectedStore(item.id);
          const data = {
            reportDate: localeDateStartDate(new Date(selectedDate)),
            endDate: localeDateEndDate(new Date(selectedEndDate))
          };
          fetchStoreOrderReport(item.id, data);

          setStoreNameData(item?.storeName);
          setSearchTerm("");
          // setSelectedRows([]);
          // setSelectedInvoiceNos([])
          // setSumOfBalanceAmount(0);
          // setSumOfOrderCount(0);
          // setPaymentMethodValue("")
          // setStoreUserValue("")
        }}
      >
        <p className="text-white text-xl font-bold uppercase">
          {item?.storeName.replace(/_/g, " ")}
        </p>
      </div>
    ));
  };

  const OrderStatusColors = {
    BOOKED: "#3EB3E1",
    INPROCESS: "#866CCE",
    PROCESSED: "#F5C43A",
    DELIVERED: "#09B4AA",
    DONE: "#55BD5A",
    CANCEL: "#FF6767",
    UNPROCESSED: "#5D53D8",
    OUT_FOR_DELIVERY: "#6EA4F5",
    DELAY_STATUS: "E89534",
    IN_WAREHOUSE: "#a906c2",
    DEFAULT: "#000",
  };

  const statusBodyTemplate = (rowData) => {
    return (
      <div className="flex flex-row justify-content-between">
        <span style={{ color: OrderStatusColors[rowData.status] }}>
          {rowData?.status?.replace(/_/g, " ")}
        </span>
      </div>
    );
  };

  const invoiceBodyTemplate = (rowData) => {
    return (
      <div>
        <span>{rowData?.invoiceNo}</span>
      </div>
    );
  };

  const collectionListTemplateHeading = (rowData) => {
    // Assuming rowData.collectionList is an array of objects with `amount` field
    return (
      <div>
        <div className="flex justify-content-center">
          <p>Payment Info</p>
        </div>
        <div className="flex">
          <p style={{ width: 100, color: "blue" }}>Amount</p>
          <p style={{ width: 150, color: "blue" }}>Payment Mode</p>
          <p style={{ width: 130, color: "blue" }}>Store User Name</p>
        </div>
      </div>
    );
  };

  const collectionListTemplate = (rowData) => {
    // Assuming rowData.collectionList is an array of objects with `amount` field
    return (
      <div>
        {rowData?.collectionList.length > 0 ? (
          rowData?.collectionList?.map((data, index) => (
            <div key={index} className="flex">
              <p style={{ width: 100 }}>{storeLocalData?.currencySymbol} {data?.amount}</p>
              <p style={{ width: 150 }}>
                {data?.paymentMode?.replace(/_/g, " ")}
              </p>
              <p style={{ width: 130 }}>{data?.storeUserName}</p>
            </div>
          ))
        ) : (
          <div className="flex">
            <p style={{ width: 100 }}></p>
            <p style={{ width: 150 }}></p>
            <p style={{ width: 130 }}>{rowData?.editBy}</p>
          </div>
        )}
      </div>
    );
  };

  const RenderTabViewInvoice = () => {
    return (
      <DataTable
        showGridlines
        value={filteredDataInvoice}
        // header={header}
        paginator
        rows={10}
        rowsPerPageOptions={[10, 25, 50]}
        tableStyle={{ minWidth: "120rem" }}
        stripedRows
      >
        <Column
          header="S No."
          style={{ width: "80px" }}
          body={(rowData, options) =>
            options.rowIndex + 1}
        ></Column>
        <Column
          field="invoiceNo"
          header="Bill No"
          style={{ width: "70px" }}
          body={invoiceBodyTemplate}
        ></Column>
        <Column
          field="customerName"
          header="Customer Name"
          style={{ width: "150px" }}
          body={(rowData) => rowData?.customerName?.replace(/_/g, " ")}
        ></Column>
        <Column
          field="customerMobile"
          header="Mobile"
          style={{ width: "100px" }}
          body={(rowData) => rowData?.customerMobile?.replace(/_/g, " ")}
        ></Column>
        <Column
          field="status"
          header="Status"
          style={{ width: "160px" }}
          body={statusBodyTemplate}
        ></Column>
        <Column
          field="grandTotal"
          header="Amount"
          style={{ width: "80px" }}
          body={(rowData) =>
            rowData?.grandTotal ? storeLocalData?.currencySymbol + " " + rowData?.grandTotal : 0
          }
        ></Column>
        <Column
          field="balanceAmount"
          header="Balance"
          style={{ width: "80px" }}
          body={(rowData) =>
            rowData?.balanceAmount ? storeLocalData?.currencySymbol + " " + rowData?.balanceAmount : 0
          }
        ></Column>

        <Column
          field="paidAmount"
          header="Paid"
          style={{ width: "80px" }}
          body={(rowData) =>
            rowData?.paidAmount ? storeLocalData?.currencySymbol + " " + rowData?.paidAmount : 0
          }
        ></Column>
        <Column
          field="discount"
          header="Delivery Discount"
          style={{ width: "80px" }}
          body={(rowData) =>
            rowData?.totalDeliveryDiscount
              ? storeLocalData?.currencySymbol + " " + rowData?.totalDeliveryDiscount
              : 0
          }
        ></Column>
        <Column
          field="due"
          header="Due"
          style={{ width: "80px" }}
          body={(rowData) => (rowData?.due ? storeLocalData?.currencySymbol + " " + rowData?.due : 0)}
        ></Column>

        <Column
          field="advance"
          header="Advance"
          style={{ width: "80px" }}
          body={(rowData) => (rowData?.advance ? storeLocalData?.currencySymbol + " " + rowData?.advance : 0)}
        ></Column>
        <Column
          field="subscriptionPackageInfo"
          header="Package"
          style={{ width: "120px" }}
          body={(rowData) =>
            rowData?.subscriptionPackageInfo
              ? rowData?.subscriptionPackageInfo
              : "N/A"
          }
        ></Column>

        <Column
          field="orderSource"
          header={collectionListTemplateHeading}
          style={{ width: "300px" }}
          body={collectionListTemplate}
        ></Column>
      </DataTable>
    );
  };

  const RenderTabViewPackage = () => {
    return (
      <DataTable
        showGridlines
        value={filteredDataPackage}
        // header={header}
        paginator
        rows={10}
        rowsPerPageOptions={[10, 25, 50]}
        tableStyle={{ minWidth: "70rem" }}
        stripedRows
      >
        <Column
          header="S No."
          style={{ width: "80px" }}
          body={(rowData, options) =>
            options.rowIndex + 1}
        ></Column>
        <Column
          field="customerName"
          header="Customer Name"
          // style={{ width: "150px" }}
          body={(rowData) => rowData?.customerName?.replace(/_/g, " ")}
        ></Column>
        <Column
          field="customerMobile"
          header="Mobile"
          // style={{ width: "100px" }}
          body={(rowData) => rowData?.customerMobile?.replace(/_/g, " ")}
        ></Column>
        <Column
          field="subscriptionPackageInfo"
          header="Package"
          // style={{ width: "80px" }}
          body={(rowData) =>
            rowData?.subscriptionPackageInfo
              ? rowData?.subscriptionPackageInfo
              : "N/A"
          }
        ></Column>

        <Column
          field="orderSource"
          header={collectionListTemplateHeading}
          style={{ width: "300px" }}
          body={collectionListTemplate}
        ></Column>
      </DataTable>
    );
  };

  const RenderTabViewWallet = () => {
    return (
      <DataTable
        showGridlines
        value={filteredDataWallet}
        // header={header}
        paginator
        rows={10}
        rowsPerPageOptions={[10, 25, 50]}
        tableStyle={{ minWidth: "80rem" }}
        stripedRows
      >
        <Column
          header="S No."
          style={{ width: "80px" }}
          body={(rowData, options) =>
            options.rowIndex + 1}
        ></Column>
        <Column
          field="customerName"
          header="Customer Name"
          // style={{ width: "150px" }}
          body={(rowData) => rowData?.customerName?.replace(/_/g, " ")}
        ></Column>
        <Column
          field="customerMobile"
          header="Mobile"
          // style={{ width: "100px" }}
          body={(rowData) => rowData?.customerMobile?.replace(/_/g, " ")}
        ></Column>
        <Column
          field="orderSource"
          header={collectionListTemplateHeading}
          style={{ width: "300px" }}
          body={collectionListTemplate}
        ></Column>
      </DataTable>
    );
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Collection Report
              </p>
            </div>
          </div>
          {searchFilterValue && (
            <div
              className="mx-2 cursor-pointer"
              onClick={() => {
                navigate("/StoreReportCollectionReceipt", {
                  state: {
                    filteredDataInvoice: filteredDataInvoice,
                    filteredDataPackage: filteredDataPackage,
                    filteredDataWallet: filteredDataWallet,
                    statusTotalData: statusTotalData,
                    statusTotalPackageData: statusTotalPackageData,
                    statusTotalWalletData: statusTotalWalletData,
                    allTotalData: allTotalData,
                    searchFilterValue: searchFilterValue,
                    storeNameData: storeNameData,
                    receiptDate: selectedDate,
                  },
                });
              }}
            >
              <img
                src={"Laundy_App_Icons_Gifs/Other_Icons/View_Invoice.png"}
                style={{
                  width: 30,
                  height: 30,
                }}
              />
            </div>
          )}
          {paymentStoreUserName.length > 0 && <div
            onClick={() => setReportUsersModalVisible(true)}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
              style={{ width: height < 600 ? 25 : 30 }}
            />
          </div>}
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div
        className="flex gap-3 my-3 mx-3 pb-1 new-scroll-bar"
        style={{
          overflowX: "auto",
          whiteSpace: "nowrap",
        }}
      >
        <div className="ml-2 flex justify-content-between  align-items-center">
          <div>
            <p className="text-xl font-semibold">Select Store : </p>
          </div>
        </div>

        {renderPaymentModeButtons()}
      </div>

      <div className="  my-2">
        <div className="my-2 mx-4 flex flex-1 justify-content-center align-items-center">
          <div className="flex-1">
            <IconField iconPosition="left" className="flex flex-1">
              <InputIcon className="pi pi-search text-xl"> </InputIcon>
              <InputText
                placeholder={"Search Here"}
                value={searchTerm}
                keyboardType={"default"}
                onChange={(e) => setSearchTerm(e.target.value)}
                // onChange={(e) => searchTermApiCall(e.target.value)}
                className="text-xl flex flex-1 py-1 px-5"
                style={{ borderRadius: 30 }}
              />
            </IconField>
          </div>

          {searchTerm && (
            <div
              className="flex justify-content-center align-items-center mx-2 cursor-pointer"
              onClick={(e) => setSearchTerm("")}
            >
              <div>
                <p className="text-4xl font-bold " style={{ color: "red" }}>
                  X
                </p>
              </div>
            </div>
          )}
          <div className="flex">
            <p className="font-bold block mx-3 mt-10 align-self-center">Start Date</p>
            <Calendar
              id="date"
              value={selectedDate}
              onChange={(e) => {
                const newDate = new Date(e.target.value);

                // Check start date cannot be greater than end date
                if (newDate > selectedEndDate) {
                  setSelectedDate(selectedEndDate);
                  return;
                }

                const currentTime = new Date();

                newDate.setHours(
                  currentTime.getHours(),
                  currentTime.getMinutes(),
                  currentTime.getSeconds(),
                  currentTime.getMilliseconds()
                );

                setSelectedDate(newDate);
              }}
              showIcon
              maxDate={selectedEndDate}
              className="bg-white-alpha-20 border-round-lg p-1 text-lg text-primary-50"
              dateFormat="dd/mm/yy"
            />
          </div>
          <div className="flex">
            <p className="font-bold block mx-3 mt-10 align-self-center">End Date</p>
            <Calendar
              id="date"
              value={selectedEndDate}
              onChange={(e) => {
                const newDate = new Date(e.target.value);

                // Check end date cannot be less than start date
                if (newDate < selectedDate) {
                  setSelectedEndDate(selectedDate);
                  return;
                }

                const currentTime = new Date();

                newDate.setHours(
                  currentTime.getHours(),
                  currentTime.getMinutes(),
                  currentTime.getSeconds(),
                  currentTime.getMilliseconds()
                );

                setSelectedEndDate(newDate);
              }}
              showIcon
              minDate={selectedDate}   // <-- add this
              maxDate={new Date()}
              className="bg-white-alpha-20 border-round-lg p-1 text-lg text-primary-50"
              dateFormat="dd/mm/yy"
            />
          </div>
        </div>
        {loading && (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        )}
        {invoiceNoResData?.length > 0 && (
          <div>
            <div
              className="flex gap-3 mb-3 mx-4 pb-1 new-scroll-bar"
              style={{
                overflowX: "auto",
                whiteSpace: "nowrap",
              }}
            >
              <div
                style={{ backgroundColor: "#2B70D7" }}
                className="px-3 py-2 border-round-md"
              >
                <p className="text-white text-lg font-bold uppercase">
                  Order Report
                </p>
              </div>
              {renderPaymentModeButtonsInvoice()}
            </div>
            <div>
              <div
                className="scroll-bar mb-2"
                style={{
                  // height: height > 600 ? 420 : 360,
                  overflowY: "scroll",
                }}
              >
                <div className="mx-4 report-table">
                  <div className="tab-view-table">{RenderTabViewInvoice()}</div>
                </div>
              </div>
            </div>
          </div>
        )}

        {packageResData?.length > 0 && (
          <div>
            <div
              className="flex gap-3 mb-3 mx-4 pb-1 new-scroll-bar"
              style={{
                overflowX: "auto",
                whiteSpace: "nowrap",
              }}
            >
              <div
                style={{ backgroundColor: "#2B70D7" }}
                className="px-3 py-2 border-round-md"
              >
                <p className="text-white text-lg font-bold uppercase">
                  Package Report
                </p>
              </div>
              {renderPaymentModeButtonsPackage()}
            </div>
            <div>
              <div
                className="scroll-bar mb-2"
                style={{
                  // height: height > 600 ? 420 : 360,
                  overflowY: "scroll",
                }}
              >
                <div className="mx-4 report-table">
                  <div className="tab-view-table">{RenderTabViewPackage()}</div>
                </div>
              </div>
            </div>
          </div>
        )}

        {walletResData?.length > 0 && (
          <div>
            <div
              className="flex gap-3 mb-3 mx-4 pb-1 new-scroll-bar"
              style={{
                overflowX: "auto",
                whiteSpace: "nowrap",
              }}
            >
              <div
                style={{ backgroundColor: "#2B70D7" }}
                className="px-3 py-2 border-round-md"
              >
                <p className="text-white text-lg font-bold uppercase">
                  Wallet Report
                </p>
              </div>
              {renderPaymentModeButtonsWallet()}
            </div>
            <div>
              <div
                className="scroll-bar mb-2"
                style={{
                  // height: height > 600 ? 420 : 360,
                  overflowY: "scroll",
                }}
              >
                <div className="mx-4 report-table">
                  <div className="tab-view-table">{RenderTabViewWallet()}</div>
                </div>
              </div>
            </div>
          </div>
        )}
        <StoreReportUserFilterModal
          setStatusFilterModalVisible={setReportUsersModalVisible}
          statusFilterModalVisible={reportUsersModalVisible}
          sendDataToOrdersPageFromFilter={handleSearchFilterChange}
          paymentReceivedByUser={paymentStoreUserName}
        />
        <AdminMenu setVisible={setVisible} visible={visible} />
      </div>
    </div>
  );
};

export default AdminReports;
